var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "PWR01G04" },
    [
      _c("div", { staticClass: "title_h1_s" }, [_vm._v("作業日程変更")]),
      _c(
        "vab-form",
        {
          ref: "form",
          attrs: {
            "label-position": "left",
            model: _vm.form,
            rules: _vm.rules,
          },
        },
        _vm._l(_vm.form.list, function (item, index) {
          return _c("div", { key: index, staticClass: "ts_box form_box" }, [
            _c(
              "div",
              {
                staticClass: "flex_space head_box flex_center_align",
                class: { margin_bottom_12: item.workFold },
              },
              [
                _c("div", { staticClass: "flex_center_align" }, [
                  _c("img", {
                    attrs: { src: require("@/assets/images/r16.png"), alt: "" },
                  }),
                  _vm.form.list.length > 1
                    ? _c(
                        "span",
                        { staticClass: "hd_title" },
                        [
                          _vm._t("hd_title", function () {
                            return [
                              _vm._v(
                                " 依頼" +
                                  _vm._s(index + 1) +
                                  "（作業No：" +
                                  _vm._s(_vm.getFieldValue("workNo", item)) +
                                  "） "
                              ),
                            ]
                          }),
                        ],
                        2
                      )
                    : _c(
                        "span",
                        { staticClass: "hd_title" },
                        [
                          _vm._t("hd_title", function () {
                            return [
                              _vm._v(
                                " 作業No：" +
                                  _vm._s(_vm.getFieldValue("workNo", item)) +
                                  " "
                              ),
                            ]
                          }),
                        ],
                        2
                      ),
                ]),
                _c("svg-icon", {
                  staticClass: "arrow_svg",
                  class: { rote: item.workFold },
                  attrs: { "icon-class": "up_line" },
                  on: {
                    click: function ($event) {
                      item.workFold = !item.workFold
                    },
                  },
                }),
              ],
              1
            ),
            item.workFold
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex_start flex_center_align margin_bottom_6",
                    },
                    [
                      _c("div", { staticClass: "split_line" }),
                      _c("span", { staticClass: "box_title" }, [
                        _vm._v("基本情報"),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "sure_box top_info mtn margin_bottom_12" },
                    [
                      _c(
                        "vab-row",
                        { staticClass: "row_box" },
                        [
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("発注No連番")]
                          ),
                          _c(
                            "vab-col",
                            { staticClass: "word_box", attrs: { span: 8 } },
                            [
                              _c(
                                "div",
                                { staticClass: "flex_space flex_center_align" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex_auto line_height" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getFieldValue(
                                              "acceptOrderNoSeq",
                                              item
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("作業年月")]
                          ),
                          _c(
                            "vab-col",
                            { staticClass: "word_box", attrs: { span: 8 } },
                            [
                              _c(
                                "div",
                                { staticClass: "flex_space flex_center_align" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex_auto line_height" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getFieldValue("workYm", item)
                                              ? _vm
                                                  .$dayjs(
                                                    _vm
                                                      .getFieldValue(
                                                        "workYm",
                                                        item
                                                      )
                                                      .toString()
                                                  )
                                                  .format("YYYY/MM")
                                              : ""
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "vab-row",
                        { staticClass: "row_box" },
                        [
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("建物")]
                          ),
                          _c(
                            "vab-col",
                            { staticClass: "word_box", attrs: { span: 8 } },
                            [
                              _c(
                                "div",
                                { staticClass: "flex_space flex_center_align" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex_auto line_height" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getFieldValue("blgsnmkj", item)
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("div", { staticClass: "sub_title" }, [
                                    _vm._v(
                                      " （建物CD：" +
                                        _vm._s(
                                          _vm.getFieldValue("buildingCd", item)
                                        ) +
                                        "） "
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("管理形態")]
                          ),
                          _c(
                            "vab-col",
                            { staticClass: "word_box", attrs: { span: 8 } },
                            [
                              _c(
                                "div",
                                { staticClass: "flex_space flex_center_align" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex_auto line_height" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getEnumText(
                                              _vm.getFieldValue("mngfrm", item),
                                              _vm.$divisions.manageFormEnum
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "vab-row",
                        { staticClass: "row_box" },
                        [
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("商品明細")]
                          ),
                          _c(
                            "vab-col",
                            { staticClass: "word_box", attrs: { span: 8 } },
                            [
                              _c(
                                "div",
                                { staticClass: "flex_space flex_center_align" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex_auto line_height" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getFieldValue("itmdtlnm", item)
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("div", { staticClass: "sub_title" }, [
                                    _vm._v(
                                      " （商品明細CD：" +
                                        _vm._s(
                                          _vm.getFieldValue(
                                            "itemDetailCd",
                                            item
                                          )
                                        ) +
                                        "） "
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("点検仕様")]
                          ),
                          _c(
                            "vab-col",
                            { staticClass: "word_box", attrs: { span: 8 } },
                            [
                              _c(
                                "div",
                                { staticClass: "flex_space flex_center_align" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex_auto line_height" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getFieldValue(
                                              "workSpecName",
                                              item
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("div", { staticClass: "sub_title" }, [
                                    _vm._v(
                                      " （点検仕様CD：" +
                                        _vm._s(
                                          _vm.getFieldValue("workSpecCd", item)
                                        ) +
                                        "） "
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "vab-row",
                        { staticClass: "row_box" },
                        [
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("協力会社")]
                          ),
                          _c(
                            "vab-col",
                            { staticClass: "word_box", attrs: { span: 8 } },
                            [
                              _c(
                                "div",
                                { staticClass: "flex_space flex_center_align" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex_auto line_height" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getFieldValue("bcnfrkj", item)
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("div", { staticClass: "sub_title" }, [
                                    _vm._v(
                                      " （協力会社CD：" +
                                        _vm._s(
                                          _vm.getFieldValue("supplierCd", item)
                                        ) +
                                        "） "
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("発注金額")]
                          ),
                          _c(
                            "vab-col",
                            {
                              staticClass:
                                "word_box flex_center_align flex_end",
                              attrs: { span: 8 },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.moneyFormat(
                                      _vm.getFieldValue("costPrice", item)
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "vab-row",
                        { staticClass: "row_box" },
                        [
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("作業条件")]
                          ),
                          _c(
                            "vab-col",
                            { attrs: { span: 20 } },
                            [
                              _c(
                                "vab-row",
                                [
                                  _c(
                                    "vab-col",
                                    {
                                      staticClass: "table_header br",
                                      attrs: { span: 24 },
                                    },
                                    [_vm._v(" 日程調整不要 ")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "vab-row",
                                [
                                  _c(
                                    "vab-col",
                                    {
                                      staticClass:
                                        "word_box8 br flex_center_align",
                                      attrs: { span: 24 },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getEnumTextChange(
                                              _vm.getFieldValue(
                                                "weekdayConditionSpecify.adjustUnnecessaryFlg",
                                                item
                                              ),
                                              _vm.$divisions.unnecessaryFlagEnum
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "vab-row",
                                [
                                  _c(
                                    "vab-col",
                                    {
                                      staticClass: "table_header br",
                                      attrs: { span: 12 },
                                    },
                                    [_vm._v(" FM不在の場合 ")]
                                  ),
                                  _c(
                                    "vab-col",
                                    {
                                      staticClass: "table_header",
                                      attrs: { span: 12 },
                                    },
                                    [_vm._v("要日程調整")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "vab-row",
                                [
                                  _c(
                                    "vab-col",
                                    {
                                      staticClass:
                                        "word_box8 br flex_center_align",
                                      attrs: { span: 12 },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.isEqualCodeEnum(
                                              item.weekdayConditionSpecify
                                                .adjustUnnecessaryFlg,
                                              _vm.$divisions.unnecessaryFlagEnum
                                                .enum_blank
                                            )
                                              ? _vm.getEnumTextChange(
                                                  _vm.getFieldValue(
                                                    "weekdayConditionSpecify.fmAbsentCheckableFlg",
                                                    item
                                                  ),
                                                  _vm.$divisions
                                                    .checkableFlgEnum
                                                )
                                              : "-"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "vab-col",
                                    {
                                      staticClass:
                                        "word_box8 flex_center_align",
                                      attrs: { span: 12 },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getEnumTextChange(
                                              _vm.getFieldValue(
                                                "weekdayConditionSpecify.needAdjustFlg",
                                                item
                                              ),
                                              _vm.$divisions.necessaryFlagEnum
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "vab-row",
                                [
                                  _c(
                                    "vab-col",
                                    {
                                      staticClass: "table_header",
                                      attrs: { span: 24 },
                                    },
                                    [_vm._v("曜日指定")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "vab-row",
                                [
                                  _c(
                                    "vab-col",
                                    {
                                      staticClass:
                                        "word_box8 flex_center_align",
                                      attrs: { span: 24 },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getTextValue(
                                              _vm.getFieldValue(
                                                "weekdayConditionSpecify.weekdayLimitContentText",
                                                item
                                              )
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "vab-row",
                                [
                                  _c(
                                    "vab-col",
                                    {
                                      staticClass:
                                        "table_header br flex_center_align",
                                      attrs: { span: 12 },
                                    },
                                    [_vm._v(" 日付指定 ")]
                                  ),
                                  _c(
                                    "vab-col",
                                    {
                                      staticClass:
                                        "table_header flex_center_align",
                                      attrs: { span: 12 },
                                    },
                                    [_vm._v(" 時間指定 ")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "vab-row",
                                [
                                  _c(
                                    "vab-col",
                                    {
                                      staticClass: "word_box8 br flex_colum",
                                      attrs: { span: 12 },
                                    },
                                    [
                                      _vm.getFieldValue(
                                        "weekdayConditionSpecify.dateLimitContentCanText",
                                        item
                                      )
                                        ? _c(
                                            "div",
                                            { staticClass: "pre_wrap" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.getTextValue(
                                                      _vm.getFieldValue(
                                                        "weekdayConditionSpecify.dateLimitContentCanText",
                                                        item
                                                      )
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.getFieldValue(
                                        "weekdayConditionSpecify.dateLimitContentCannotText",
                                        item
                                      )
                                        ? _c("div", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getTextValue(
                                                    _vm.getFieldValue(
                                                      "weekdayConditionSpecify.dateLimitContentCannotText",
                                                      item
                                                    )
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                  _c(
                                    "vab-col",
                                    {
                                      staticClass: "word_box8",
                                      attrs: { span: 12 },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getTextValue(
                                              _vm.getFieldValue(
                                                "weekdayConditionSpecify.timeLimitContentText",
                                                item
                                              )
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "vab-row",
                                [
                                  _c(
                                    "vab-col",
                                    {
                                      staticClass:
                                        "table_header br flex_center_align",
                                      attrs: { span: 12 },
                                    },
                                    [_vm._v(" お知らせ文 ")]
                                  ),
                                  _c(
                                    "vab-col",
                                    {
                                      staticClass:
                                        "table_header flex_center_align",
                                      attrs: { span: 12 },
                                    },
                                    [_vm._v(" 報告書 ")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "vab-row",
                                [
                                  _c(
                                    "vab-col",
                                    {
                                      staticClass:
                                        "word_box8 br flex_center_align",
                                      attrs: { span: 12 },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getTextValue(
                                              _vm.getFieldValue(
                                                "weekdayConditionSpecify.notifyText",
                                                item
                                              )
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "vab-col",
                                    {
                                      staticClass:
                                        "word_box8 flex_center_align",
                                      attrs: { span: 12 },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getTextValue(
                                              _vm.getFieldValue(
                                                "weekdayConditionSpecify.reportText",
                                                item
                                              )
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "vab-row",
                                [
                                  _c(
                                    "vab-col",
                                    {
                                      staticClass: "table_header",
                                      attrs: { span: 24 },
                                    },
                                    [_vm._v(" 自由コメント ")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "vab-row",
                                [
                                  _c(
                                    "vab-col",
                                    {
                                      staticClass:
                                        "word_box8 flex_center_align",
                                      attrs: { span: 24 },
                                    },
                                    [
                                      _c("div", { staticClass: "pre_wrap" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.getTextValue(
                                                _vm.getFieldValue(
                                                  "weekdayConditionSpecify.freeComment",
                                                  item
                                                )
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "vab-row",
                        { staticClass: "row_box" },
                        [
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("ステータス")]
                          ),
                          _c(
                            "vab-col",
                            { staticClass: "word_box", attrs: { span: 20 } },
                            [
                              _c(
                                "div",
                                { staticClass: "flex_space flex_center_align" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex_auto line_height" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getEnumTextChange(
                                              _vm.getFieldValue(
                                                "changeStatus",
                                                item
                                              ),
                                              _vm.$divisions.wparStatusEnum
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex_start flex_center_align margin_bottom_6",
                    },
                    [
                      _c("div", { staticClass: "split_line" }),
                      _c("span", { staticClass: "box_title" }, [
                        _vm._v("依頼情報"),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "span_subtitle flex_center_align" },
                    [
                      _c("svg-icon", {
                        attrs: { "icon-class": "warning_line" },
                      }),
                      _vm._v(" 支払い条件：完了確認月末締め翌月20日払い "),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "sure_box top_info mtn" },
                    [
                      _c(
                        "vab-row",
                        { staticClass: "row_box" },
                        [
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("依頼日")]
                          ),
                          _c(
                            "vab-col",
                            { staticClass: "word_box", attrs: { span: 8 } },
                            [
                              _c(
                                "div",
                                { staticClass: "flex_space flex_center_align" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex_auto line_height" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getFieldValue(
                                              "changeRequestDate",
                                              item
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("調整理由")]
                          ),
                          _c(
                            "vab-col",
                            { staticClass: "word_box", attrs: { span: 8 } },
                            [
                              _c(
                                "div",
                                { staticClass: "flex_space flex_center_align" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex_auto line_height" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getFieldValue(
                                              "notAllowDateReason",
                                              item
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "vab-row",
                        { staticClass: "row_box" },
                        [
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("依頼内容")]
                          ),
                          _c(
                            "vab-col",
                            {
                              staticClass: "word_box padding_3_12",
                              attrs: { span: 8 },
                            },
                            [
                              _vm.isChangeCategory(item) && !item.isMonthFlg
                                ? [
                                    _c("vab-select", {
                                      ref: "changeCategoryRef",
                                      refInFor: true,
                                      staticClass: "width_80",
                                      attrs: {
                                        prop:
                                          "list." + index + ".changeCategory",
                                        label: "依頼種別",
                                        "label-width": "110px",
                                        "data-items": _vm.changeCategoryList,
                                        "label-id": "text",
                                        "value-id": "value",
                                        validate: "required",
                                        placeholder: "選択されていません",
                                      },
                                      on: {
                                        change: function (val) {
                                          _vm.changeSelectCategory(val, index)
                                        },
                                      },
                                    }),
                                    _c("vab-date-picker", {
                                      staticClass: "width_80",
                                      attrs: {
                                        type: "month",
                                        label: "変更後の月",
                                        "label-width": "110px",
                                        "value-format": "yyyyMM",
                                        format: "M月",
                                        prop: "list." + index + ".changeMonth",
                                        disabled: item.monthDisabled,
                                      },
                                    }),
                                    _c("vab-input", {
                                      staticClass: "width_80",
                                      attrs: {
                                        prop: "list." + index + ".changeWorkNo",
                                        label: "変更後作業No",
                                        "label-width": "110px",
                                        disabled: true,
                                      },
                                    }),
                                  ]
                                : [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex_space flex_center_align",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex_auto line_height",
                                          },
                                          [
                                            _vm._v(
                                              " 依頼種別：" +
                                                _vm._s(
                                                  _vm.getEnumText(
                                                    _vm.getFieldValue(
                                                      "changeCategory",
                                                      item
                                                    ),
                                                    _vm.$divisions
                                                      .changeCategoryEnum
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex_space flex_center_align",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex_auto line_height",
                                          },
                                          [
                                            _vm._v(
                                              " 変更後の月：" +
                                                _vm._s(
                                                  _vm.getChangeMonth(
                                                    _vm.getFieldValue(
                                                      "changeMonth",
                                                      item
                                                    )
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex_space flex_center_align",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex_auto line_height",
                                          },
                                          [
                                            _vm._v(
                                              " 変更後作業No：" +
                                                _vm._s(
                                                  _vm.getFieldValue(
                                                    "changeWorkNo",
                                                    item
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                            ],
                            2
                          ),
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("日程回答期限")]
                          ),
                          _c(
                            "vab-col",
                            {
                              staticClass: "word_box flex_center_align",
                              attrs: { span: 8 },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getFieldValue("answerDeadline", item) ||
                                      "-"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "vab-row",
                        { staticClass: "row_box" },
                        [
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("変更前日時")]
                          ),
                          _c(
                            "vab-col",
                            { staticClass: "word_box", attrs: { span: 8 } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex_space flex_center_align ht_box",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex_center_align line_height",
                                    },
                                    [
                                      _vm.getFieldValue("workChangeDate", item)
                                        ? _c(
                                            "div",
                                            { staticClass: "margin_right_12" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.formatWorkPlanDate(
                                                      item.workChangeDate,
                                                      item.workYm
                                                    )
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.isShow(
                                                      item.workChangeDate,
                                                      item.workChangeStartTime,
                                                      item.workChangeEndTime
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c("div", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formatTimeMsel(
                                                item.workChangeStartTime,
                                                "HH:mm"
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.getFieldValue(
                                                "workChangeStartTime",
                                                item
                                              )
                                                ? "〜"
                                                : ""
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.formatTimeMsel(
                                                item.workChangeEndTime,
                                                "HH:mm"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v(" 作業予定（変更後日時） ")]
                          ),
                          _vm.workChangeSpecial(item)
                            ? _c(
                                "vab-col",
                                {
                                  staticClass: "word_box padding_3_12",
                                  class: {
                                    flex_center_align: !(
                                      _vm.isEqualCodeEnum(
                                        item.changeStatus,
                                        _vm.$divisions.wparStatusEnum.enum_08
                                      ) && !item.isMonthFlg
                                    ),
                                  },
                                  attrs: { span: 8 },
                                },
                                [
                                  _vm.isEqualCodeEnum(
                                    item.changeStatus,
                                    _vm.$divisions.wparStatusEnum.enum_08
                                  ) && !item.isMonthFlg
                                    ? _c("vab-checkbox", {
                                        attrs: {
                                          label: "未定",
                                          nullable: true,
                                        },
                                        on: {
                                          change: function (val) {
                                            _vm.checkboxWorkPlan(val, index)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex_center_align width_265 time_weekshow time_60",
                                    },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c("vab-time", {
                                            staticClass: "time14",
                                            attrs: {
                                              prop:
                                                "list." +
                                                index +
                                                ".workPlanDate",
                                              ym: item.workPlanDate,
                                              disabled: item.workDateFlag,
                                              "week-show": true,
                                              "work-change": true,
                                            },
                                            on: {
                                              svgClick: function ($event) {
                                                return _vm.openDay(item, index)
                                              },
                                              change: function ($event) {
                                                return _vm.timeReset(
                                                  $event,
                                                  index
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex_center_align flex_start pd_10",
                                        },
                                        [
                                          _c("vab-time-input", {
                                            staticClass: "time14 work_time",
                                            attrs: {
                                              disabled:
                                                item.workDateFlag ||
                                                _vm.$baseLodash.isEmpty(
                                                  item.workPlanDate
                                                ),
                                              prop:
                                                "list." +
                                                index +
                                                ".workPlanStartTime",
                                              "label-error": "予定日時",
                                              validate: _vm.vaildateTimeStart(
                                                item,
                                                index
                                              ),
                                              "row-item": { isUpdate: true },
                                            },
                                            model: {
                                              value: item.workPlanStartTime,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "workPlanStartTime",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.workPlanStartTime",
                                            },
                                          }),
                                          _c("div", { staticClass: "mg8" }, [
                                            _vm._v("〜"),
                                          ]),
                                          _c("vab-time-input", {
                                            staticClass: "time14 work_time",
                                            attrs: {
                                              disabled:
                                                item.workDateFlag ||
                                                _vm.$baseLodash.isEmpty(
                                                  item.workPlanDate
                                                ),
                                              prop:
                                                "list." +
                                                index +
                                                ".workPlanEndTime",
                                              "label-error": "予定日時",
                                              validate: _vm.vaildateTimeEnd(
                                                item,
                                                index
                                              ),
                                              "row-item": { isUpdate: true },
                                            },
                                            model: {
                                              value: item.workPlanEndTime,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "workPlanEndTime",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.workPlanEndTime",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "vab-col",
                                { staticClass: "word_box", attrs: { span: 8 } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex_space flex_center_align ht_box",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex_center_align line_height",
                                        },
                                        [
                                          _vm.getFieldValue(
                                            "workPlanDate",
                                            item
                                          )
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "margin_right_12",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.formatWorkPlanDate(
                                                          item.workPlanDate,
                                                          item.workYm
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.isShow(
                                                          item.workPlanDate,
                                                          item.workPlanStartTime,
                                                          item.workPlanEndTime
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c("div", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatTimeMsel(
                                                    item.workPlanStartTime,
                                                    "HH:mm"
                                                  )
                                                ) +
                                                " " +
                                                _vm._s(
                                                  _vm.getFieldValue(
                                                    "workPlanStartTime",
                                                    item
                                                  )
                                                    ? "〜"
                                                    : ""
                                                ) +
                                                " " +
                                                _vm._s(
                                                  _vm.formatTimeMsel(
                                                    item.workPlanEndTime,
                                                    "HH:mm"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                        ],
                        1
                      ),
                      _c(
                        "vab-row",
                        { staticClass: "row_box" },
                        [
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("現地確認要否")]
                          ),
                          _c(
                            "vab-col",
                            {
                              staticClass:
                                "word_box radio_box padding_8_12 flex_center_align",
                              attrs: { span: 8 },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex_space flex_center_align" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex_auto line_height" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getEnumText(
                                              _vm.getFieldValue(
                                                "localComfirmFlg",
                                                item
                                              ),
                                              _vm.$divisions.unnecessaryFlagEnum
                                            ) || "-"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("現地確認")]
                          ),
                          _vm.workChangeSpecial(item) && !item.workDateFlag
                            ? _c(
                                "vab-col",
                                {
                                  staticClass:
                                    "word_box radio_box padding_8_12 flex_center_align",
                                  attrs: { span: 8 },
                                },
                                [
                                  _c("vab-radio-group", {
                                    ref: "localAdjRef" + index,
                                    refInFor: true,
                                    staticClass: "margin_0",
                                    attrs: {
                                      prop: "list." + index + ".localAdjFlg",
                                      filter: "localAdjFlg",
                                      "code-enum":
                                        _vm.$divisions.localAdjFlgEnum,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _c(
                                "vab-col",
                                {
                                  staticClass:
                                    "word_box radio_box padding_8_12 flex_center_align",
                                  attrs: { span: 8 },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex_space flex_center_align",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex_auto line_height",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.getEnumText(
                                                  _vm.getFieldValue(
                                                    "localAdjFlg",
                                                    item
                                                  ),
                                                  _vm.$divisions.localAdjFlgEnum
                                                ) || "-"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                        ],
                        1
                      ),
                      _c(
                        "vab-row",
                        { staticClass: "row_box" },
                        [
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("協力会社コメント")]
                          ),
                          _c(
                            "vab-col",
                            {
                              staticClass: "word_box padding_8_12",
                              attrs: { span: 20 },
                            },
                            [
                              _c("vab-textarea", {
                                staticClass: "margin_0",
                                attrs: {
                                  placeholder: "",
                                  "label-width": "1",
                                  prop: "list." + index + ".dlnConfirmComment",
                                  rows: "5",
                                  "show-word-limit": "",
                                  maxlength: "500",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "vab-row",
                        { staticClass: "row_box mess_box" },
                        [
                          _c("vab-messagerc", {
                            ref: "vabMessage" + index,
                            refInFor: true,
                            staticClass:
                              "detail_nopadding message_collapse width_100 noborder",
                            attrs: { title: "コメント履歴を閉じる" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex_space mg12" },
                    [
                      _c("div", { staticClass: "flex_start" }, [
                        _c(
                          "div",
                          { staticClass: "blgsnmkj_class" },
                          [
                            _c("svg-icon", {
                              staticClass: "svg_icon",
                              attrs: { "icon-class": "select_work" },
                            }),
                            _c(
                              "el-link",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.goCalendar(
                                      item.buildingCd,
                                      item.workYm,
                                      index,
                                      item
                                    )
                                  },
                                },
                              },
                              [_vm._v(" カレンダーを表示 ")]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("vab-button", {
                        attrs: {
                          "btn-list": item.btnList,
                          row: Object.assign({}, item, { index: index }),
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ])
        }),
        0
      ),
      _vm.form.list.length > 1
        ? _c(
            "div",
            { staticClass: "flex_end flex_center_align mt_12" },
            [_c("vab-button", { attrs: { "btn-list": _vm.btnlist } })],
            1
          )
        : _vm._e(),
      _c("WorkPopupCalender", {
        ref: "WorkPopupCalender",
        staticClass: "work_popup_calender",
      }),
      _c("fixedTime", {
        ref: "fixedTime",
        staticClass: "work_popup_calender",
        on: { saveData: _vm.saveData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }